import { useMemo } from 'react';

import { getResolvedFields } from 'utilities/NodeType';
import { useNodeTypes } from 'context/NodeTypesContext';

const BUILTIN_SCHEMA_FIELD_TYPES = new Set([
  'color',
  'icon',
  'cover',
  'description',
  'dates',
  'location',
  'tags',
]);

export default function useNodeFormFields({
  nodeTypeKey,
  language,
  typeDef,
  overrideFields,
}) {
  const { getRevision } = useNodeTypes();
  const nodeTypesRevision = getRevision();

  const resolvedFields = useMemo(() => {
    void nodeTypesRevision;
    return getResolvedFields(nodeTypeKey, { includeHidden: false, excludeSecured: true });
  }, [nodeTypeKey, nodeTypesRevision]);

  const sourceFields = useMemo(() => {
    if (Array.isArray(overrideFields)) return overrideFields;
    return resolvedFields;
  }, [overrideFields, resolvedFields]);

  const fields = useMemo(
    () => sourceFields.filter((f) => {
      if (!f || f.hidden === true || f.secured === true) return false;
      if (!f.name || !f.type) return false;
      if (BUILTIN_SCHEMA_FIELD_TYPES.has(f.type) && f.source && f.source !== nodeTypeKey) return false;
      return Boolean(f.label);
    }),
    [sourceFields, nodeTypeKey]
  );
  return { fields, resolvedFields };
}
